import { Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";
import { DownloadPage } from "./pages/DownloadPage";
import { HomePage } from "./pages/HomePage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { PricingPage } from "./pages/PricingPage";
import { AccountPage } from "./pages/AccountPage";
import { LegalPage } from "./pages/LegalPage";
import { InviteAttribution } from "./components/InviteAttribution";

export function SiteRoutes() {
  return (
    <><InviteAttribution /><Routes>
      <Route path="account/*" element={<AccountPage />} />
      <Route element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="pricing" element={<PricingPage />} />
        <Route path="download" element={<DownloadPage />} />
        <Route path="terms" element={<LegalPage kind="terms" />} />
        <Route path="privacy" element={<LegalPage kind="privacy" />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes></>
  );
}

export default SiteRoutes;
